// Vanilla CSS for StatusError. Prefix: serr-. Aggregated into libraryStyles.
// A tone (danger/warning/info) drives every accented surface through CSS vars,
// so switching severity is one class change (.serr-tone-*). Colors are pulled
// from the Playful Frost palette (--catchup-red / -orange / -blue-*).
export const errorStyles = `
  .serr-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--space-3);
    max-width: 22rem;
    text-align: center;
    font-family: var(--font-sans);
    /* Tone contract (defaults to danger) */
    --serr-c1: #ff9a9a; --serr-c2: #ff6b6b; --serr-c3: #e23d3d;
    --serr-accent: #e23d3d; --serr-eyebrow: #c62b2b; --serr-tint: 255,107,107;
  }
  .serr-tone-danger  { --serr-c1:#ff9a9a; --serr-c2:#ff6b6b; --serr-c3:#e23d3d; --serr-accent:#e23d3d; --serr-eyebrow:#c62b2b; --serr-tint:255,107,107; }
  .serr-tone-warning { --serr-c1:#fca98f; --serr-c2:#f98066; --serr-c3:#e85f42; --serr-accent:#e05c3c; --serr-eyebrow:#c24a2e; --serr-tint:249,128,102; }
  .serr-tone-info    { --serr-c1:var(--brand-light); --serr-c2:var(--catchup-blue-500); --serr-c3:var(--brand-dark); --serr-accent:var(--brand-dark); --serr-eyebrow:var(--catchup-blue-700); --serr-tint:84,187,203; }

  .serr-pill {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    border-radius: var(--rad-catchup-full);
    color: var(--serr-accent);
    background:
      radial-gradient(120% 120% at 30% 24%, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0) 55%),
      linear-gradient(160deg, rgba(var(--serr-tint),0.16) 0%, rgba(var(--serr-tint),0.08) 100%);
    border: 1px solid rgba(var(--serr-tint),0.32);
    box-shadow:
      inset 0 1px 1px rgba(255,255,255,0.9),
      0 6px 16px rgba(var(--serr-tint),0.20);
  }
  .serr-pill-ring {
    position: absolute;
    inset: -6px;
    border-radius: var(--rad-catchup-full);
    border: 2px solid rgba(var(--serr-tint),0.28);
    opacity: 0;
  }
  @media (prefers-reduced-motion: no-preference) {
    .serr-pill-ring { animation: serrPillPulse 2.6s ease-out infinite; }
  }
  @keyframes serrPillPulse {
    0%   { transform: scale(0.9); opacity: 0.55; }
    70%  { transform: scale(1.25); opacity: 0; }
    100% { transform: scale(1.25); opacity: 0; }
  }

  .serr-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 12px 3px 10px;
    border-radius: var(--rad-catchup-full);
    background: rgba(var(--serr-tint),0.12);
    border: 1px solid rgba(var(--serr-tint),0.28);
    font-size: var(--fs-xs);
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--serr-eyebrow);
  }
  .serr-eyebrow::before {
    content: '';
    width: 6px; height: 6px;
    border-radius: var(--rad-catchup-full);
    background: var(--serr-accent);
    box-shadow: 0 0 0 3px rgba(var(--serr-tint),0.18);
  }

  .serr-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-2);
  }
  .serr-code {
    margin: 0;
    font-size: 60px;
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 1;
    background: linear-gradient(135deg, var(--serr-c1) 0%, var(--serr-c2) 60%, var(--serr-c3) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-variant-numeric: tabular-nums;
  }
  .serr-message {
    margin: 0;
    font-size: var(--fs-lg);
    font-weight: 700;
    line-height: 1.45;
    color: var(--catchup-dark-blue);
    max-width: 20rem;
  }
  .serr-help {
    margin: 0;
    font-size: var(--fs-md);
    font-weight: 500;
    line-height: 1.55;
    color: var(--catchup-gray-400);
    max-width: 19rem;
  }
`;
